export default __webpack_public_path__ + "static/media/ic-question.07b3f5c0.svg";